import type { ComponentChildren, FunctionComponent } from 'preact';
import FocusLock from 'react-focus-lock';

import type { Props as SearchBoxProps } from 'Components/searchBox/searchBox';
import type { TemplateResult } from 'Components/types';
import { usePopup } from 'Core/hooks/index';

import SearchBox from '../searchBox/searchBox';

export const dialogName = 'SearchBoxDialog';

const FocusLockCompat = FocusLock as FunctionComponent<{
  children?: ComponentChildren;
}>;

const SearchBoxDialog: FunctionComponent<SearchBoxProps> = (props) => {
  const { opened, close } = usePopup(dialogName);

  if (!opened) {
    return null;
  }

  const onSubmit = () => {
    close();
    props.onSubmit?.();
  };

  const searchBoxProps = {
    ...props,
    name: dialogName,
    onSubmit,
    extraParams: { close },
    disableAutoRequest: true,
  };

  return (
    <FocusLockCompat>
      <SearchBox {...searchBoxProps} />
    </FocusLockCompat>
  ) as TemplateResult;
};

export default SearchBoxDialog;
